import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Color from 'color';

import FONT_FAMILY from '../../../constants/fontFamily';
import FontFamilyHeader from '../../FontFamilyHeader';
import { DateProvider } from '../../../providers';
import LogoImg from './logo.png';
import {
  Container,
  Fault,
  FaultsContainerLeft,
  FaultsContainerRight,
  FaultsPointsContainer,
  Logo,
  LogoContainer,
  Points,
  PointsContainer,
  QuarterTime,
  Separator,
  TeamName,
  Timer,
} from './styles';

function BasketballLebPlata({ data, isBuilder }) {
  const { awayTeam, homeTeam, quarter, status, time } = data;
  const [, refresh] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => refresh(Date.now()), 1000);
    if (status === 'paused') clearInterval(interval);
    return () => {
      clearInterval(interval);
    };
  }, [status]);

  const getTime = () => {
    if (time.length === 0) return '10:00';
    const [minutes, seconds] = DateProvider.getBasketballTime(time);
    return `${minutes}:${seconds}`;
  };

  return (
    <>
      <FontFamilyHeader family={FONT_FAMILY.ciutadella} />
      <Container isBuilder={isBuilder}>
        <LogoContainer>
          <Logo src={LogoImg} />
        </LogoContainer>
        <TeamName
          style={{
            background: homeTeam.color,
            color: Color(homeTeam.color).isDark() ? '#ffffff' : '#000000',
          }}
        >
          {homeTeam.name}
        </TeamName>
        <PointsContainer>
          <svg
            width="40"
            height="82"
            viewBox="0 0 40 82"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M40 0L0 82V0H40Z" fill={homeTeam.color} />
          </svg>
          <FaultsPointsContainer>
            <Points>{homeTeam.points}</Points>
            <FaultsContainerLeft>
              {Array.from({ length: 5 }).map((_, index) => (
                <Fault
                  key={index}
                  active={index < homeTeam.faults}
                  index={index}
                />
              ))}
            </FaultsContainerLeft>
          </FaultsPointsContainer>
          <Separator />
          <FaultsPointsContainer>
            <Points>{awayTeam.points}</Points>
            <FaultsContainerRight>
              {Array.from({ length: 5 }).map((_, index) => (
                <Fault
                  key={index}
                  active={index < awayTeam.faults}
                  index={index}
                />
              ))}
            </FaultsContainerRight>
          </FaultsPointsContainer>
          <svg
            width="40"
            height="82"
            viewBox="0 0 40 82"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0 0L40 82V0H0Z" fill={awayTeam.color} />
          </svg>
        </PointsContainer>
        <TeamName
          style={{
            background: awayTeam.color,
            color: Color(awayTeam.color).isDark() ? '#ffffff' : '#000000',
          }}
        >
          {awayTeam.name}
        </TeamName>
        <QuarterTime>{`${quarter}º`}</QuarterTime>
        <Separator />
        <Timer>{getTime()}</Timer>
      </Container>
    </>
  );
}

BasketballLebPlata.propTypes = {
  data: PropTypes.shape({
    awayTeam: PropTypes.shape({
      color: PropTypes.string,
      faults: PropTypes.number,
      name: PropTypes.string,
      points: PropTypes.number,
    }),
    homeTeam: PropTypes.shape({
      color: PropTypes.string,
      faults: PropTypes.number,
      name: PropTypes.string,
      points: PropTypes.number,
    }),
    quarter: PropTypes.number,
    status: PropTypes.string,
    time: PropTypes.arrayOf(PropTypes.number),
  }),
  styles: PropTypes.shape({}),
};

BasketballLebPlata.defaultProps = {
  data: {
    awayTeam: {
      color: '#D0333A',
      faults: 0,
      name: 'VIS',
      points: 0,
    },
    homeTeam: {
      color: '#FFFFFF',
      faults: 0,
      name: 'LOC',
      points: 0,
    },
    quarter: 1,
    status: 'paused',
    time: [],
  },
  styles: {},
};

export default BasketballLebPlata;
